module.exports = __webpack_public_path__ + "img/2.faaee837.jpg";